import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { DOCUMENTS } from 'constants/routeConstants';
import checkmarkIcon from 'assets/images/icons/checkmark-green-square.svg';
import checkmarkBoxEmpty from 'assets/images/icons/checkmark-empty-square.svg';
import Button from 'shared/components/Button/Button';
import InfoModal from '../../common-components/InfoModal/InfoModal';

interface IRenewalTermsModalProps {
  show: boolean;
  onContinue: () => void;
  onClose: () => void;
}

const RenewalTermsModal: React.FC<IRenewalTermsModalProps> = ({ show, onContinue, onClose }) => {
  const [accepted, setAccepted] = useState(false);

  const navigate = useNavigate();

  const dummyPath = ''; // Dummy filepath created to avoid linting errors

  const toggleAccepted = () => setAccepted((prev) => !prev);

  return (
    <InfoModal
      show={show}
      heading={undefined}
      footer={undefined}
      testId="renewal-terms-modal"
      size="lg"
      closeModal={undefined}
      className={undefined}
    >
      <div className="mx-auto" style={{ maxWidth: '509px' }}>
        <h4 className="text-center">Before you continue</h4>
        <p className="text-center">Please confirm you’ve reviewed your renewal document before continuing.</p>
        <div className="form-check p-0 m-0 d-flex align-items-start">
          <button
            type="button"
            role="checkbox"
            aria-checked={accepted}
            aria-labelledby="renewal-terms-label"
            onClick={toggleAccepted}
            className="bg-transparent border-0 m-0 p-0"
          >
            <img src={accepted ? checkmarkIcon : checkmarkBoxEmpty} alt="" height="24" width="24" />
          </button>
          <span id="renewal-terms-label" className="px-2">
            I’ve read the <a onClick={(e) => { e.preventDefault(); navigate(DOCUMENTS); }} href={dummyPath}>renewal document</a>, which includes my cover details and last year’s price.
          </span>
        </div>
        <div className="mt-4">
          <Button
            onClickHandler={onContinue}
            buttonText="Continue"
            disabled={!accepted}
            greyButton={undefined}
            darkGreyButton={undefined}
            outlineBlack={undefined}
            loading={undefined}
          />
        </div>
        <div className="text-center mt-3">
          <button type="button" onClick={onClose} className="btn text-muted text-decoration-underline p-0">
            Go back
          </button>
        </div>
      </div>
    </InfoModal>
  );
};

export default RenewalTermsModal;
